import axiosInstance from './axiosInstance';

export type InvitationReply = 'accept' | 'decline';

/** Accept or decline the signed-in user's own pending invitation to a project, or to the organization that owns it. */
export const replyToProjectInvitation = async (projectId: string, reply: InvitationReply): Promise<void> => {
  await axiosInstance.post(`/api/v1/projects/${encodeURIComponent(projectId)}/invitation/${reply}`);
};
